/**
 * Parse engineering/suffix notation into base SI number.
 * Accepts: 1uF, 5nH, 10k, 20mA, 2.2m, 100R, 0.001 (plain number).
 * Prefixes: p, n, u/µ, m, k, M, G (case-insensitive for letter).
 */

const PREFIX = {
  p: 1e-12,
  n: 1e-9,
  u: 1e-6,
  µ: 1e-6,
  m: 1e-3,
  k: 1e3,
  M: 1e6,
  G: 1e9,
};

/**
 * @param {string} str - e.g. "1uF", "5nH", "10k", "20mA", "2.2"
 * @returns {number|null} - value in base SI, or null if invalid
 */
export function parseEngineering(str) {
  if (str == null || typeof str !== 'string') return null;
  const s = str.trim().replace(',', '.').replace(/\s+/g, '');
  if (s === '') return null;
  // Match: optional sign, digits (optional decimal), optional prefix letter, optional unit letter
  // Allow p, n, u or µ (micro), m, k, M, G and optional unit letter F, H, A, V, Ω, R, z, Hz
  const match = s.match(/^([+-]?\d*\.?\d+)\s*([pnuµmkMG])?\s*([FHAVΩRz]|Hz)?$/i);
  if (!match) return null;
  const num = parseFloat(match[1]);
  if (!Number.isFinite(num)) return null;
  const prefixChar = match[2] || '';
  // u and µ (and U) mean micro; keep M vs m for mega vs milli
  const mult = (prefixChar === 'µ' || prefixChar === 'u' || prefixChar === 'U') ? 1e-6 : (PREFIX[prefixChar] ?? PREFIX[prefixChar.toLowerCase()] ?? 1);
  return num * mult;
}

/** Input class for toolkit light theme (professional calculator look) */
export const inputClass =
  'w-full px-3 py-2 rounded-lg border border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none';
/** Result box class */
export const resultClass =
  'p-4 rounded-lg border border-gray-200 bg-gray-50 text-gray-800';
/** Label class */
export const labelClass = 'block text-gray-600 text-sm font-medium mb-1';
/** Hint/paragraph text */
export const hintClass = 'text-gray-500 text-sm';
